import { ConsumeCostType } from './overview';

export enum BalanceType {
  Expenses = '1', // 1-支出
  InCome = '2', // 2-收入；
}

export interface IBalanceItem {
  readonly total: string; // 数据总数
  readonly size: string; // 每页数量
  readonly list: Array<IBalanceList>;
}
// export enum TransactionType {
//   Freeze = '1', // 冻结
//   PostpaidBill = '2', // 后付费账单支出
//   PrepaidService = '3', // 支付预付费服务
//   Withdrawal = '4', // 提现
// }

export interface IBalanceList {
  readonly id: string; // 流水号
  readonly create_time: string; // 交易时间
  readonly amount: string; // 交易金额
  readonly channel: string; // 交易渠道
  readonly status: BalanceType; // 收支类型
  readonly type: ConsumeCostType; // 交易类型
  readonly balance: string; // 剩余可用金额
  readonly remark?: string; // 备注
}

export enum BillOrderMode {
  Postpaid = 1,
  Prepayment = 2,
}

export enum BillOrderType {
  NewlyPurchased = 1,
  Renew = 2,
}

export enum BillOrderArea {
  Singapore = 0,
  China = 1,
  Woa = 2,
}

export interface IBillOrder {
  readonly area: BillOrderArea;
  readonly env_id: number;
  readonly game_id: number;
  readonly order_mode: BillOrderMode;
  readonly order_type: BillOrderType;
  readonly service_id: number;
  readonly service_name: string;
  readonly subservice_name: string;
}

export interface IBillList {
  readonly bill_end_date: string;
  readonly bill_id: string;
  readonly bill_start_date: string;
  readonly create_time: string;
  readonly delete_operator: string | null;
  readonly extra_info: string;
  readonly game_id: number;
  readonly pay_money: string | null;
  readonly pay_status: number;
  readonly service_id: number;
  readonly studio_id: string;
  readonly total_cost: string;
  readonly update_time: string;
  readonly order: IBillOrder;
}

export interface IBillListItem {
  readonly total: string; // 数据总数
  readonly size: string; // 每页数量
  readonly list: Array<IBillList>;
}

export interface IBillMonthCost {
  readonly amount: number;
  readonly billed: boolean;
  readonly end_date: string;
  readonly start_date: string;
}
